import { render, staticRenderFns } from "./LiveLinkReplacement.vue?vue&type=template&id=2899692a&scoped=true"
import script from "./LiveLinkReplacement.vue?vue&type=script&lang=js"
export * from "./LiveLinkReplacement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2899692a",
  null
  
)

export default component.exports